import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, withCtx as _withCtx, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, mergeProps as _mergeProps, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "fill-height background_image" }
const _hoisted_2 = {
  key: 1,
  class: "display-1 d-flex align-center",
  style: {"height":"70px"}
}
const _hoisted_3 = {
  key: 1,
  class: "display-1 d-flex align-center",
  style: {"height":"70px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_profile_menu = _resolveComponent("profile-menu")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_hover = _resolveComponent("v-hover")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item_subtitle = _resolveComponent("v-list-item-subtitle")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.$vuetify.display.mobile)
      ? (_openBlock(), _createBlock(_component_v_row, {
          key: 0,
          "no-gutters": "",
          class: "background_image d-flex d-flex justify-center"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, { cols: "1" }),
            _createVNode(_component_v_col, {
              cols: "10",
              class: "d-flex justify-center py-6"
            }, {
              default: _withCtx(() => [
                (_ctx.logo)
                  ? (_openBlock(), _createBlock(_component_v_img, {
                      key: 0,
                      src: _ctx.logo,
                      height: "70px"
                    }, null, 8, ["src"]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.currentUser.company.name), 1))
              ]),
              _: 1
            }),
            _createVNode(_component_v_col, {
              cols: "1",
              class: "d-flex justify-end py-6 pr-6"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_profile_menu)
              ]),
              _: 1
            }),
            _createVNode(_component_v_col, {
              cols: "11",
              class: "d-flex pt-6",
              style: {"height":"calc(100vh - 156px)"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_row, { "no-gutters": "" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, {
                      cols: "3",
                      class: "px-3",
                      style: {"height":"85%","overflow":"hidden"},
                      onClick: _ctx.routerProd
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_hover, null, {
                          default: _withCtx(({ isHovering, props }) => [
                            _createVNode(_component_v_row, _mergeProps(props, {
                              "no-gutters": "",
                              class: "fill-height"
                            }), {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, {
                                  cols: "12",
                                  style: {"height":"100%","transition":"all 280ms ease"}
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_card, {
                                      elevation: "0",
                                      class: _normalizeClass(["rounded-lg pa-10 card-overlay", isHovering ? 'hovering-card' : 'not-hovering-card']),
                                      ripple: ""
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_card_title, { class: "card-text-title" }, {
                                          default: _withCtx(() => _cache[0] || (_cache[0] = [
                                            _createTextVNode("Production")
                                          ])),
                                          _: 1
                                        }),
                                        _createVNode(_component_v_card_text, {
                                          class: "card-text-description",
                                          style: {"min-height":"120px"}
                                        }, {
                                          default: _withCtx(() => _cache[1] || (_cache[1] = [
                                            _createTextVNode(" Collecte, traitement, saisie, révision, restitution ")
                                          ])),
                                          _: 1
                                        }),
                                        _createVNode(_component_v_col, { cols: "12" }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_img, {
                                              src: "img/bobbee3d/bobbee3d1.png",
                                              height: "120px",
                                              width: "100%",
                                              class: _normalizeClass(
                                                    isHovering ? 'hovering-img' : 'not-hovering-img'
                                                )
                                            }, null, 8, ["class"]),
                                            _createVNode(_component_v_img, {
                                              height: "15%",
                                              width: "75%",
                                              style: {"left":"10%"},
                                              src: "img/production.png"
                                            })
                                          ]),
                                          _: 2
                                        }, 1024)
                                      ]),
                                      _: 2
                                    }, 1032, ["class"])
                                  ]),
                                  _: 2
                                }, 1024),
                                _createVNode(_component_v_img, {
                                  src: "img/bobbee3d/bobbee3d1.png",
                                  height: "120px",
                                  style: {"position":"absolute","top":"280px","left":"20px"},
                                  class: _normalizeClass(isHovering ? 'hovering-img' : 'not-hovering-img')
                                }, null, 8, ["class"])
                              ]),
                              _: 2
                            }, 1040)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["onClick"]),
                    _createVNode(_component_v_col, {
                      cols: "3",
                      class: "px-3",
                      style: {"height":"85%","overflow":"hidden"},
                      onClick: _ctx.routeGed
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_hover, null, {
                          default: _withCtx(({ isHovering, props }) => [
                            _createVNode(_component_v_row, _mergeProps(props, {
                              "no-gutters": "",
                              class: "fill-height"
                            }), {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, {
                                  cols: "12",
                                  style: {"height":"100%","transition":"all 280ms ease"}
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_card, {
                                      elevation: "0",
                                      class: _normalizeClass(["rounded-lg pa-10 card-overlay", isHovering ? 'hovering-card' : 'not-hovering-card']),
                                      ripple: ""
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_card_title, { class: "card-text-title" }, {
                                          default: _withCtx(() => _cache[2] || (_cache[2] = [
                                            _createTextVNode("GED")
                                          ])),
                                          _: 1
                                        }),
                                        _createVNode(_component_v_card_text, {
                                          class: "card-text-description",
                                          style: {"min-height":"120px"}
                                        }, {
                                          default: _withCtx(() => _cache[3] || (_cache[3] = [
                                            _createTextVNode(" DP, DA, DR, documents ")
                                          ])),
                                          _: 1
                                        }),
                                        _createVNode(_component_v_col, { cols: "12" }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_img, {
                                              src: "img/bobbee3d/bobbee3d2.png",
                                              height: "140px",
                                              width: "100%",
                                              class: _normalizeClass(
                                                    isHovering ? 'hovering-img' : 'not-hovering-img'
                                                )
                                            }, null, 8, ["class"]),
                                            _createVNode(_component_v_img, {
                                              height: "15%",
                                              width: "75%",
                                              style: {"left":"10%"},
                                              src: "img/ged.png"
                                            })
                                          ]),
                                          _: 2
                                        }, 1024)
                                      ]),
                                      _: 2
                                    }, 1032, ["class"])
                                  ]),
                                  _: 2
                                }, 1024),
                                _createVNode(_component_v_img, {
                                  src: "img/bobbee3d/bobbee3d2.png",
                                  height: "140px",
                                  style: {"position":"absolute","top":"280px","left":"20px"},
                                  class: _normalizeClass(isHovering ? 'hovering-img' : 'not-hovering-img')
                                }, null, 8, ["class"])
                              ]),
                              _: 2
                            }, 1040)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["onClick"]),
                    _createVNode(_component_v_col, {
                      cols: "3",
                      class: "px-3",
                      style: {"height":"85%","overflow":"hidden"},
                      onClick: _ctx.routeAdminHome
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_hover, null, {
                          default: _withCtx(({ isHovering, props }) => [
                            _createVNode(_component_v_row, _mergeProps(props, {
                              "no-gutters": "",
                              class: "fill-height"
                            }), {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, {
                                  cols: "12",
                                  style: {"height":"100%","transition":"all 280ms ease"}
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_card, {
                                      elevation: "0",
                                      class: _normalizeClass(["rounded-lg pa-10 card-overlay", isHovering ? 'hovering-card' : 'not-hovering-card']),
                                      ripple: "",
                                      "data-cy": "Homepage-gestionInterne"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_card_title, {
                                          "data-cy": "homepage-GI",
                                          class: "card-text-title"
                                        }, {
                                          default: _withCtx(() => _cache[4] || (_cache[4] = [
                                            _createTextVNode("Gestion interne")
                                          ])),
                                          _: 1
                                        }),
                                        _createVNode(_component_v_card_text, {
                                          class: "card-text-description",
                                          style: {"min-height":"120px"}
                                        }, {
                                          default: _withCtx(() => _cache[5] || (_cache[5] = [
                                            _createTextVNode(" Equipe, dossiers, temps, Boni/Mali, facturation, déontologie ")
                                          ])),
                                          _: 1
                                        }),
                                        _createVNode(_component_v_col, { cols: "12" }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_img, {
                                              src: "img/bobbee3d/bobbee3d3.png",
                                              height: "160px",
                                              width: "100%",
                                              class: _normalizeClass(
                                                    isHovering ? 'hovering-img' : 'not-hovering-img'
                                                )
                                            }, null, 8, ["class"]),
                                            _createVNode(_component_v_img, {
                                              height: "15%",
                                              width: "75%",
                                              style: {"left":"10%"},
                                              src: "img/gi.png"
                                            })
                                          ]),
                                          _: 2
                                        }, 1024)
                                      ]),
                                      _: 2
                                    }, 1032, ["class"])
                                  ]),
                                  _: 2
                                }, 1024),
                                _createVNode(_component_v_img, {
                                  src: "img/bobbee3d/bobbee3d3.png",
                                  height: "160px",
                                  style: {"position":"absolute","top":"280px","left":"20px"},
                                  class: _normalizeClass(isHovering ? 'hovering-img' : 'not-hovering-img')
                                }, null, 8, ["class"])
                              ]),
                              _: 2
                            }, 1040)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["onClick"]),
                    _createVNode(_component_v_col, {
                      cols: "3",
                      class: "px-3",
                      style: {"height":"85%","overflow":"hidden"},
                      onClick: _ctx.routerDocumentation
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_hover, null, {
                          default: _withCtx(({ isHovering, props }) => [
                            _createVNode(_component_v_row, _mergeProps(props, {
                              "no-gutters": "",
                              class: "fill-height"
                            }), {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, {
                                  cols: "12",
                                  style: {"height":"100%","transition":"all 280ms ease"}
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_card, {
                                      elevation: "0",
                                      class: _normalizeClass(["rounded-lg pa-10 card-overlay", isHovering ? 'hovering-card' : 'not-hovering-card']),
                                      ripple: ""
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_card_title, { class: "card-text-title" }, {
                                          default: _withCtx(() => _cache[6] || (_cache[6] = [
                                            _createTextVNode("Les + de bobbee")
                                          ])),
                                          _: 1
                                        }),
                                        _createVNode(_component_v_card_text, {
                                          class: "card-text-description",
                                          style: {"min-height":"120px"}
                                        }, {
                                          default: _withCtx(() => _cache[7] || (_cache[7] = [
                                            _createTextVNode(" Articles, blog, forum ")
                                          ])),
                                          _: 1
                                        }),
                                        _createVNode(_component_v_col, { cols: "12" }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_img, {
                                              src: "img/bobbee3d/bobbee3d1.png",
                                              height: "120px",
                                              width: "100%",
                                              class: _normalizeClass(
                                                    isHovering ? 'hovering-img' : 'not-hovering-img'
                                                )
                                            }, null, 8, ["class"]),
                                            _createVNode(_component_v_img, {
                                              height: "15%",
                                              width: "75%",
                                              style: {"left":"10%"},
                                              src: "img/lesplusbobbee.png"
                                            })
                                          ]),
                                          _: 2
                                        }, 1024)
                                      ]),
                                      _: 2
                                    }, 1032, ["class"])
                                  ]),
                                  _: 2
                                }, 1024),
                                _createVNode(_component_v_img, {
                                  src: "img/bobbee3d/bobbee3d1.png",
                                  height: "120px",
                                  style: {"position":"absolute","top":"280px","left":"20px"},
                                  class: _normalizeClass(isHovering ? 'hovering-img' : 'not-hovering-img')
                                }, null, 8, ["class"])
                              ]),
                              _: 2
                            }, 1040)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_col, {
              cols: "12",
              class: "d-flex align-center pb-2 pr-2 justify-start"
            }, {
              default: _withCtx(() => _cache[8] || (_cache[8] = [
                _createTextVNode(" Powered by "),
                _createElementVNode("img", {
                  src: "img/bobbee_hrz.png",
                  height: "30px",
                  class: "mb-1 ml-1"
                }, null, -1)
              ])),
              _: 1
            })
          ]),
          _: 1
        }))
      : (_openBlock(), _createBlock(_component_v_row, {
          key: 1,
          "no-gutters": "",
          class: "background_image d-flex d-flex justify-center fill-height"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, { cols: "2" }),
            _createVNode(_component_v_col, {
              cols: "8",
              class: "d-flex justify-center py-6"
            }, {
              default: _withCtx(() => [
                (_ctx.logo)
                  ? (_openBlock(), _createBlock(_component_v_img, {
                      key: 0,
                      src: _ctx.logo,
                      height: "50px"
                    }, null, 8, ["src"]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.currentUser.company.name), 1))
              ]),
              _: 1
            }),
            _createVNode(_component_v_col, {
              cols: "2",
              class: "d-flex justify-end py-6 pr-6"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_profile_menu)
              ]),
              _: 1
            }),
            _createVNode(_component_v_col, { cols: "12" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_list, { style: {"background":"transparent"} }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sections, (item, index) => {
                      return (_openBlock(), _createBlock(_component_v_list_item, {
                        key: index,
                        ripple: "",
                        class: "ma-1",
                        onClick: ($event: any) => (item.route())
                      }, {
                        append: _withCtx(() => [
                          _createVNode(_component_v_icon, null, {
                            default: _withCtx(() => _cache[9] || (_cache[9] = [
                              _createTextVNode("$chevron_right")
                            ])),
                            _: 1
                          })
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_v_list_item_title, null, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(item.title), 1)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_v_list_item_subtitle, null, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(item.subtitle), 1)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1032, ["onClick"]))
                    }), 128))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_col, {
              cols: "12",
              class: "d-flex justify-end align-end pr-2 pb-2"
            }, {
              default: _withCtx(() => [
                _cache[10] || (_cache[10] = _createTextVNode(" Powered by ")),
                _createVNode(_component_v_img, {
                  src: "img/bobbee_hrz.png",
                  height: "25px",
                  class: "mb-1 ml-1 mr-3"
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
  ]))
}